import { ROUTES } from "@constants/routes";

export const DRIVE_DOMAIN_WHITE_LIST = [
	'buy-gamepass',
	'terms',
	'banned',
	'bot',
	'dashboard',
	'drive',
	'testdrive',
	'mission',
	'playgame',
	'personal',
	'openworldcontrolremotekeybindings',
	'openworldkeyboardkeybindings',
	'openworldplaycontrollers',
	'openworldwheelkeybindings',
	'testdrivecontroller',
	'testdrivecontrolremotekeybinding',
	'testdrivekeyboardkeybinding',
	'testdrivewheelkeybinding',
	'stripe',
	'404',
	'/'
];

export const MY_DOMAIN_WHITE_LIST = [
	'buy-gamepass',
	'terms',
	'banned',
	'activate',
	'activate-account',
	'dashboard-login',
	'activate-login',
	'activate-minting',
	'activate-test-drive',
	'ownerwheelkeybindings',
	'ownerplaycontrollers',
	'ownerkeyboardkeybindings',
	'ownercontrolremotekeybindings',
	'owner-drive',
	'owner',
	'stripe',
	'404',
  ROUTES.mobilePlayControllers
];
